import { createAction, props } from '@ngrx/store';
import { User } from '../../interfaces/common/users';

export const Login = createAction('[AUTH] Login Action', props<{user: User}>());
export const Logout = createAction('[AUTH] Logout Action', props<{redirect: string}>());
